// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-message[data-v-14ffb107] {\n    color: var(--color-pinky-red);\n    font-size: 12px;\n    margin-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
